import React from 'react';
import {
    Stack,
    Button,
    TextField,
} from '@shopify/polaris';
import {
    DeleteMajor,
} from '@shopify/polaris-icons';

export function StringValueEntry(props) {

    function onValueUpdate(value) {
        props.onUpdate(props.index, value);
    }

    var placeholder = "Enter value";

if (props.placeholderText != null) {
        placeholder = props.placeholderText;
    }

    return <div style={{ 'paddingBottom': '10px' }}>
        <Stack alignment="center">
            <Stack.Item fill>
                <TextField
                    placeholder={placeholder}
                    value={props.value}
                    // error={props.value ? "Value is required" : null}
                    onChange={onValueUpdate}
                    autoComplete="off"
                />
            </Stack.Item>
            <Stack.Item>
                <Button destructive icon={DeleteMajor} onClick={() => props.onDelete(props.index)}></Button>
            </Stack.Item>
        </Stack>
    </div>
}